import { Context, createContext, PropsWithChildren, useContext } from 'react'
import { IMainData } from '../interfaces/maindata'
import { IWebMenu } from '../interfaces/webMenu'

const AppContext: Context<IAppContext> = createContext({} as IAppContext)

interface IAppContext {
  webmenus: { [key: string]: IWebMenu }
  mainData: IMainData
  activePage: IWebMenu | undefined
  highContrastOn: boolean
  setHighContrastOn: (highContrastOn: boolean) => void;
  accessibilityShown: boolean;
  setAccessibilityShown: (accessibilityShown: boolean) => void;
}
interface IAppWrapperProps extends IAppContext, PropsWithChildren { }

export const AppWrapper: React.FC<IAppWrapperProps> = ({
  children,
  webmenus,
  mainData,
  activePage,
  highContrastOn,
  setHighContrastOn,
  accessibilityShown,
  setAccessibilityShown
}) => {
  return (
    <AppContext.Provider
      value={{ webmenus: webmenus, mainData: mainData, activePage: activePage, highContrastOn: highContrastOn, setHighContrastOn: setHighContrastOn, accessibilityShown: accessibilityShown, setAccessibilityShown: setAccessibilityShown }}
    >
      {children}
    </AppContext.Provider>
  )
}

export function useAppContext(): IAppContext {
  return useContext<IAppContext>(AppContext)
}
